import * as cons from './constants';
import { requestReducerMaker, initialState } from '../helper'

export const getCourseCategoriesForSelection = (state = initialState, action) => requestReducerMaker(cons.GET_COURSE_CATEGORIES_FOR_SELECTION, state, action);